import { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { RegistrationContext } from '../../../context/registration';

import { fetchOtherTermClauses } from '~/services/options';
import { setOtherTermClauses } from '~/services/registration';

import { Loading } from '../../../shared/components/Loading';
import parse from 'html-react-parser';
import {
    Container,
    Button,
    Card,
    CardBody,
    Col,
    Row,
    Form,
    FormGroup,
    Input,
    Label,
} from 'reactstrap';

interface ClauseOption {
    id: number;
    template: string;
    agree: boolean;
}

export const Other = ({}: any) => {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [clauseOptions, setClauseOptions] = useState<ClauseOption[]>([]);
    const history = useHistory();
    const [{ campaignRequest }, registrationDispatch] =
        useContext(RegistrationContext);

    const getOtherTerms = async () => {
        const resp = await fetchOtherTermClauses();
        const opts = resp.map((opt) => {
            return {
                id: opt.id,
                template: opt.template,
                agree: false,
            };
        });
        setClauseOptions(opts);
        setLoading(false);
    };

    useEffect(() => {
        getOtherTerms();
    }, []);

    const handleNext = async () => {
        try {
            setSaving(true);
            const term_clause_ids = clauseOptions.map((x) => x.id);
            const resp = await setOtherTermClauses({
                term_clause_ids,
            });
            console.log('resp: ', resp);

            registrationDispatch({
                type: 'set_campaign_request',
                application: resp,
            });

            history.push('/get-started/patient/who');
        } catch (e) {
            setSaving(false);
            console.log('e: ', e);
        }
    };

    const handleCheck = (i) => {
        let newOpts = [...clauseOptions];
        newOpts[i]['agree'] = !newOpts[i]['agree'];
        console.log('newOpts: ', newOpts);
        setClauseOptions(newOpts);
    };

    if (loading) {
        return <Loading />;
    }

    const disableNext = clauseOptions.filter((x) => !x.agree).length > 0;

    return (
        <Container>
            <Form>
                <Row className='justify-content-center py-5'>
                    <Col md='6'>
                        <div className='text-center'>
                            <h3>
                                Someone is lucky to know you! Here are a few key
                                things to understand before you continue.
                            </h3>
                            <Card
                                className='box-shadow my-5'
                                style={{
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                }}
                            >
                                <CardBody>
                                    {clauseOptions.map((clause, i) => {
                                        return (
                                            <FormGroup
                                                check
                                                className='mb-3'
                                                key={i}
                                            >
                                                {parse(clause.template)}
                                                <Label check>
                                                    <Input
                                                        id={`clause-${i}`}
                                                        type='checkbox'
                                                        onChange={() =>
                                                            handleCheck(i)
                                                        }
                                                        name={`clause-${i}`}
                                                    />
                                                    I accept
                                                </Label>
                                            </FormGroup>
                                        );
                                    })}
                                </CardBody>
                            </Card>
                        </div>
                    </Col>
                </Row>

                <div className='text-center mb-5'>
                    <Button
                        color='primary'
                        onClick={handleNext}
                        // type='submit'
                        disabled={saving || disableNext}
                    >
                        {saving ? `Saving...` : `Next`}
                    </Button>
                </div>
            </Form>
        </Container>
    );
};
